<template>
    <div>
        <a href="javascript:void(0)" title="Add New Subcontractor" v-if="showButton" v-on:click="openSubcontractorModel = true">
            <small><i class="fa fa-plus"></i> Create New Subcontractor</small>
        </a>

        <b-modal
            v-model="openSubcontractorModel"
            title="New Subcontractor"
            size="lg"
            ok-title="Create Subcontractor"
            ok-variant="success"
            :ok-disabled="saving"
            :hide-disabled="saving"
            no-fade
            @hide="handleHide"
            @hidden="handleHidden"
            @ok="handleOk"
            ref="subcontractorModal"
            :no-close-on-backdrop="true"
            scrollable>

            <div class="form-group row">
                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Name: <i class="fa fa-asterisk text-danger"></i></label>
                <div class="col-md-7 col-sm-8">
                    <input type="text" v-model="subcontractor.subcontractor_name" :class="{'form-control': true, 'is-invalid': errors.subcontractor_name}" placeholder="Subcontractor Name" />
                    <span v-if="errors.subcontractor_name" class="text-danger">
                        <span v-for="error in errors.subcontractor_name">{{ error }}</span>
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Approved Until:</label>
                <div class="col-md-7 col-sm-8">
                    <b-form-input type="date" v-model="subcontractor.valid_until" placeholder="Enter Approved Until Date" />

                    <div v-if="errors.valid_until" class="text-danger">
                        <span v-for="error in errors.valid_until">{{ error }}</span>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-md-3 col-sm-4 col-form-label text-sm-right">
                    Osha Exempt:
                </div>
                <label class="col-md-7 col-sm-8">
                    <b-form-checkbox class="float-right mr-0" v-model="subcontractor.is_osha_exempt" :value="1" :unchecked-value="0" plain>
                        This subcontractor is exempt from being required to provide OSHA data during the Pre-Qualification process
                    </b-form-checkbox>

                    <div v-if="errors.is_osha_exempt" class="text-danger">
                        <span v-for="error in errors.is_osha_exempt">{{ error }}</span>
                    </div>
                </label>
            </div>

        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            showButton: {
                type: Boolean,
                default: true,
            },
            empDetails: {
                type: Object,
            },
        },

        data: function() {
            return {
                saving: false,
                subcontractor: {
                    subcontractor_id: null,
                    subcontractor_name: null,
                    is_osha_exempt: 0,
                    status_id: 1, //This is the In Progress Status
                    valid_until: null,
                },
                openSubcontractorModel: false,
                errors: {},
            }
        },

        methods: {

            show(){
                this.openSubcontractorModel = true;
            },

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.subcontractor = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveSubcontractor();
            },

            saveSubcontractor(){
                //Helper
                this.saving = true;

                //IF there is an approved date, then change the status to approved
                if(this.subcontractor.valid_until)
                {
                    this.subcontractor.status_id = 3; //Approved
                }

                //Send it
                this.$http
                    .post('subcontractors/edit', this.subcontractor)
                    //.get('admin/divisions-list')
                    .then(response => {
                        //Close the modal
                        this.$refs.subcontractorModal.hide();

                        //Return to main list?
                        this.$emit('subcontractorCreated', response.data);

                    })
                    .catch(xhr => {
                        //Check xhr error
                        if(xhr.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = xhr.response.data;
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(xhr.response.data, 'Failed to Save Subcontractor');
                        }
                    })
                    .then(() => {
                        //Reset
                        this.saving = false;
                    });
            },
        },

        mounted() {
            //SEt the height
            //console.log(this.$refs.subcontractorModal.$refs);
            //this.$refs.subcontractorModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
            //this.getSubcontractor();
        }
    }
</script>